import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

/**
 * Logout component
 *
 * Navigates to this route to clear client authentication state and redirect to the login page.
 * This is primarily useful for automated tests that rely on `page.goto('/logout')` but also
 * allows manual users to bookmark a direct logout URL.
 */
const Logout: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Perform logout side-effects then send the user to the login screen.
    logout();
    navigate("/login", { replace: true });
  }, [logout, navigate]);

  return null;
};

export default Logout; 